import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import Select from 'components/forms/Select';
import { resultsToOptions, flattenKeyPairArray } from 'utils/misc';

import { getAccountSequences, getSequences } from 'redux/actions/sequenceActions';


class SequencesFilter extends Component {
  static propTypes = {
    value: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    onChange: PropTypes.func.isRequired,
    sequences: PropTypes.shape({
      results: PropTypes.shape({}.isRequired),
    }).isRequired,
    getAccountSequences: PropTypes.func.isRequired,
    getSequences: PropTypes.func.isRequired,
    accountId: PropTypes.number,
    isCampaignReportsTab: PropTypes.bool,
    campaign: PropTypes.number,
    campaignIds: PropTypes.arrayOf(PropTypes.number),
    accountIds: PropTypes.arrayOf(PropTypes.number),
  }

  static defaultProps = {
    campaign: null,
    accountId: null,
    campaignIds: [],
    accountIds: [],
    isCampaignReportsTab: false,
  };

  state = {
    loading: false,
    options: [],
  }

  componentDidMount = () => {
    this.loadOptions('', true);
  }

  componentDidUpdate = (prevProps) => {
    const prevAccountIds = flattenKeyPairArray(prevProps.accountIds, 'value').join(',');
    const accountIds = flattenKeyPairArray(this.props.accountIds, 'value').join(',');
    const prevCampaignIds = flattenKeyPairArray(prevProps.campaignIds, 'value').join(',');
    const campaignIds = flattenKeyPairArray(this.props.campaignIds, 'value').join(',');
    if (prevAccountIds !== accountIds || prevCampaignIds !== campaignIds) {
      this.loadOptions('');
    }
  }

  loadOptions = (filterString, preventReload) => {
    this.setState({
      loading: true,
      options: [],
    }, async () => {
      if (this.props.isCampaignReportsTab) {
        await this.props.getSequences(this.props.campaign, {
          search: filterString,
        });
      } else {
        /* eslint-disable camelcase */
        let campaign__account__id = this.props.accountId ? [this.props.accountId] : undefined;
        if (this.props.accountIds) {
          campaign__account__id = flattenKeyPairArray(this.props.accountIds, 'value').join(',') || undefined;
        }
        await this.props.getAccountSequences({
          search: filterString,
          campaign__account__id,
          campaign__id: this.props.campaignIds ?
            flattenKeyPairArray(this.props.campaignIds, 'value').join(',') || undefined : undefined,
        });
      }

      const options = resultsToOptions(this.props.sequences.results, 'name') || [];

      this.setState({
        loading: false,
        options,
      }, () => {
        if (!preventReload) {
          this.props.onChange(this.props.value.filter(el => options.find(op => op.value === el.value)));
        }
      });
    });
  }

  render() {
    const { value, onChange } = this.props;
    return (
      <Select
        isMulti
        placeholder="Sequences"
        value={value}
        onChange={onChange}
        cacheOptions
        defaultOptions
        options={this.state.options}
        isLoading={this.state.loading}
        onInputChange={input => this.loadOptions(input, true)}
      />
    );
  }
}

export default compose(connect(
  state => ({ sequences: state.sequences }),
  { getAccountSequences, getSequences },
))(SequencesFilter);
